export const colourData = [
    {
        name: 'Default',
        values: [
            {
                description: 'Main Body Background',
                name: 'mainBackground',
                key: 'MAIN_BACKGROUND_COLOUR',
                default: '#e4e5e6',
            },
            {
                description: 'Secondary Body Background',
                name: 'secondaryBackground',
                key: 'SECONDARY_BACKGROUND_COLOUR',
                default: '#ffffff',
            },
            {
                description: 'Main Sidebar Background',
                name: 'sidebarMain',
                key: 'SIDEBAR_MAIN_COLOUR',
                default: '#1f2028',
            },
            {
                description: 'Secondary Sidebar Background',
                name: 'sidebarSecondary',
                key: 'SIDEBAR_SECONDARY_COLOUR',
                default: '#1f2028',
            },
        ],
    },
    {
        name: 'Vapourwave',
        values: [
            {
                description: 'Main Body Background',
                name: 'mainBackground',
                key: 'MAIN_BACKGROUND_COLOUR',
                default: '#ff71ce',
            },
            {
                description: 'Secondary Body Background',
                name: 'secondaryBackground',
                key: 'SECONDARY_BACKGROUND_COLOUR',
                default: '#01cdfe',
            },
            {
                description: 'Main Sidebar Background',
                name: 'sidebarMain',
                key: 'SIDEBAR_MAIN_COLOUR',
                default: '#05ffa1',
            },
            {
                description: 'Secondary Sidebar Background',
                name: 'sidebarSecondary',
                key: 'SIDEBAR_SECONDARY_COLOUR',
                default: '#b967ff',
            },
        ],
    },
    {
        name: 'Lions Gate',
        values: [
            {
                description: 'Main Body Background',
                name: 'mainBackground',
                key: 'MAIN_BACKGROUND_COLOUR',
                default: '#fb7b4f',
            },
            {
                description: 'Secondary Body Background',
                name: 'secondaryBackground',
                key: 'SECONDARY_BACKGROUND_COLOUR',
                default: '#fdc166',
            },
            {
                description: 'Main Sidebar Background',
                name: 'sidebarMain',
                key: 'SIDEBAR_MAIN_COLOUR',
                default: '#fd962d',
            },
            {
                description: 'Secondary Sidebar Background',
                name: 'sidebarSecondary',
                key: 'SIDEBAR_SECONDARY_COLOUR',
                default: '#02dfce',
            },
        ],
    },
    {
        name: 'Summer Salad',
        values: [
            {
                description: 'Main Body Background',
                name: 'mainBackground',
                key: 'MAIN_BACKGROUND_COLOUR',
                default: '#e35e3c',
            },
            {
                description: 'Secondary Body Background',
                name: 'secondaryBackground',
                key: 'SECONDARY_BACKGROUND_COLOUR',
                default: '#ba5889',
            },
            {
                description: 'Main Sidebar Background',
                name: 'sidebarMain',
                key: 'SIDEBAR_MAIN_COLOUR',
                default: '#00bd59',
            },
            {
                description: 'Secondary Sidebar Background',
                name: 'sidebarSecondary',
                key: 'SIDEBAR_SECONDARY_COLOUR',
                default: '#ffffff',
            },
        ],
    },
    {
        name: 'Cozy Beach',
        values: [
            {
                description: 'Main Body Background',
                name: 'mainBackground',
                key: 'MAIN_BACKGROUND_COLOUR',
                default: '#f0dcb6',
            },
            {
                description: 'Secondary Body Background',
                name: 'secondaryBackground',
                key: 'SECONDARY_BACKGROUND_COLOUR',
                default: '#fbf0ce',
            },
            {
                description: 'Main Sidebar Background',
                name: 'sidebarMain',
                key: 'SIDEBAR_MAIN_COLOUR',
                default: '#e5f9f5',
            },
            {
                description: 'Secondary Sidebar Background',
                name: 'sidebarSecondary',
                key: 'SIDEBAR_SECONDARY_COLOUR',
                default: '#9ee9ff',
            },
        ],
    },
    {
        name: 'Darkwood Greens',
        values: [
            {
                description: 'Main Body Background',
                name: 'mainBackground',
                key: 'MAIN_BACKGROUND_COLOUR',
                default: '#838c5a',
            },
            {
                description: 'Secondary Body Background',
                name: 'secondaryBackground',
                key: 'SECONDARY_BACKGROUND_COLOUR',
                default: '#626240',
            },
            {
                description: 'Main Sidebar Background',
                name: 'sidebarMain',
                key: 'SIDEBAR_MAIN_COLOUR',
                default: '#494d2e',
            },
            {
                description: 'Secondary Sidebar Background',
                name: 'sidebarSecondary',
                key: 'SIDEBAR_SECONDARY_COLOUR',
                default: '#2b2c1c',
            },
        ],
    },
    {
        name: 'Night Time',
        values: [
            {
                description: 'Main Body Background',
                name: 'mainBackground',
                key: 'MAIN_BACKGROUND_COLOUR',
                default: '#000000',
            },
            {
                description: 'Secondary Body Background',
                name: 'secondaryBackground',
                key: 'SECONDARY_BACKGROUND_COLOUR',
                default: '#000000',
            },
            {
                description: 'Main Sidebar Background',
                name: 'sidebarMain',
                key: 'SIDEBAR_MAIN_COLOUR',
                default: '#000000',
            },
            {
                description: 'Secondary Sidebar Background',
                name: 'sidebarSecondary',
                key: 'SIDEBAR_SECONDARY_COLOUR',
                default: '#000000',
            },
        ],
    },
]

const getContrast = hexcolor => {
    // If a leading # is provided, remove it
    if (hexcolor.slice(0, 1) === '#') {
        hexcolor = hexcolor.slice(1)
    }

    // If a three-character hexcode, make six-character
    if (hexcolor.length === 3) {
        hexcolor = hexcolor
            .split('')
            .map(function(hex) {
                return hex + hex
            })
            .join('')
    }

    // Convert to RGB value
    var r = parseInt(hexcolor.substr(0, 2), 16)
    var g = parseInt(hexcolor.substr(2, 2), 16)
    var b = parseInt(hexcolor.substr(4, 2), 16)

    // Get YIQ ratio
    var yiq = (r * 299 + g * 587 + b * 114) / 1000

    // Check contrast
    return yiq >= 150 ? 'black' : 'white'
}

const loadColours = colours => {
    const themeIndex = localStorage.getItem('THEME_INDEX')

    return {
        selected: colours[themeIndex ? themeIndex : 0].values.reduce(
            (prev, curr) => {
                const storageValue = localStorage.getItem(curr.key)
                const colour = storageValue ? storageValue : curr.default
                prev[curr.name] = {
                    ...curr,
                    value: colour,
                    text: getContrast(colour),
                }
                return prev
            },
            {}
        ),
        themes: colours,
    }
}

const clearColours = colours =>
    colours.forEach(e => localStorage.removeItem(e.key))

const theme = data => {
    let defaultColours = loadColours(data)

    return (state, action) => {
        if (action.type === 'SELECT_THEME') {
            localStorage.setItem('THEME_INDEX', action.theme)
            clearColours(Object.values(state.selected))
            defaultColours = loadColours(data)
            return defaultColours
        }

        const colour = Object.values(data[0].values).filter(
            d => `CHANGE_${d.key}` === action.type
        )[0]

        if (colour) {
            localStorage.setItem(colour.key, action.colour)
            const nextState = {
                ...state,
            }

            nextState.selected[colour.name].value = action.colour

            const text = getContrast(action.colour)
            nextState.selected[colour.name].text = text

            return nextState
        }

        return state ? state : defaultColours
    }
}

export default theme(colourData)



// WEBPACK FOOTER //
// ./app/reducers/theme.js